// AAC After School Program - Comprehensive Error Prevention Fix
(function() {
    'use strict';
    
    // Fix 1: Override problematic querySelector operations
    const originalQuerySelector = document.querySelector;
    const originalQuerySelectorAll = document.querySelectorAll;
    
    // Wrap querySelector to prevent classList errors
    document.querySelector = function(selector) {
        const element = originalQuerySelector.call(this, selector);
        if (!element && selector === '.clearHeader') {
            // Return a dummy element that won't cause errors
            return {
                classList: {
                    add: function() {},
                    remove: function() {},
                    contains: function() { return false; },
                    toggle: function() {}
                },
                style: {},
                addEventListener: function() {},
                removeEventListener: function() {}
            };
        }
        return element;
    };
    
    // Fix 2: Patch classList access globally
    const originalClassList = Object.getOwnPropertyDescriptor(Element.prototype, 'classList');
    Object.defineProperty(Element.prototype, 'classList', {
        get: function() {
            if (!this || !originalClassList) {
                // Return a safe dummy classList
                return {
                    add: function() {},
                    remove: function() {},
                    contains: function() { return false; },
                    toggle: function() {}
                };
            }
            try {
                return originalClassList.get.call(this);
            } catch (e) {
                return {
                    add: function() {},
                    remove: function() {},
                    contains: function() { return false; },
                    toggle: function() {}
                };
            }
        },
        configurable: true
    });
    
    // Fix 3: Override any existing smooth scroll implementations that might cause errors
    if (typeof jQuery !== 'undefined') {
        // Intercept jQuery animations that might fail
        const originalAnimate = jQuery.fn.animate;
        jQuery.fn.animate = function(properties, duration, easing, complete) {
            // Check if we're animating scrollTop
            if (properties && properties.scrollTop !== undefined) {
                // Get the target element
                const target = this.get(0);
                if (!target || (this.selector && jQuery(this.selector).length === 0)) {
                    console.warn('AAC: Attempted to scroll to non-existent element');
                    return this;
                }
                
                // Check if the scrollTop target has a valid offset
                if (typeof properties.scrollTop === 'object' && properties.scrollTop.offset) {
                    const offsetElement = properties.scrollTop;
                    if (!offsetElement || !offsetElement.offset || typeof offsetElement.offset !== 'function') {
                        console.warn('AAC: Invalid offset element for scrollTop');
                        return this;
                    }
                    
                    try {
                        const offset = offsetElement.offset();
                        if (!offset || typeof offset.top === 'undefined') {
                            console.warn('AAC: Element has no valid offset');
                            return this;
                        }
                        properties.scrollTop = offset.top;
                    } catch (e) {
                        console.warn('AAC: Error getting offset:', e);
                        return this;
                    }
                }
            }
            
            // Call the original animate function
            return originalAnimate.apply(this, arguments);
        };
    }
    
    // Our smooth scroll implementation
    function initSmoothScroll() {
        console.log('AAC: Initializing smooth scroll');
        
        // Function to handle smooth scrolling
        function smoothScrollToSection(e) {
            const link = e.target.closest('a[href^="#"]');
            if (!link) return;
            
            const targetId = link.getAttribute('href');
            if (!targetId || targetId === '#' || targetId === '') return;
            
            console.log('AAC: Attempting to scroll to:', targetId);
            
            let targetElement = null;
            
            // Map the anchor IDs to actual section IDs
            if (targetId === '#enrollment-options') {
                targetElement = document.getElementById('shopify-section-template--17108006207586__product_block_MTFjUB');
                console.log('AAC: Found enrollment section:', targetElement);
            } else if (targetId === '#contact') {
                targetElement = document.getElementById('shopify-section-template--17108006207586__contact_section');
                console.log('AAC: Found contact section:', targetElement);
            } else {
                // Try to find the element normally
                try {
                    targetElement = document.querySelector(targetId);
                } catch (error) {
                    return; // Invalid selector, let default behavior handle it
                }
            }
            
            // If target element exists, scroll to it
            if (targetElement) {
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
                
                const headerHeight = 100;
                const elementPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
                const offsetPosition = elementPosition - headerHeight;
                
                console.log('AAC: Scrolling to position:', offsetPosition);
                
                try {
                    window.scrollTo({
                        top: offsetPosition,
                        behavior: 'smooth'
                    });
                } catch (error) {
                    // Fallback for older browsers
                    window.scrollTo(0, offsetPosition);
                }
                
                // Also try jQuery scroll if available
                if (typeof jQuery !== 'undefined') {
                    jQuery('html, body').stop(true, true).animate({
                        scrollTop: offsetPosition
                    }, 800);
                }
                
                return false;
            }
        }
        
        // Add event listener with capture phase
        document.addEventListener('click', smoothScrollToSection, true);
        
        // Also add specific handlers to our buttons
        setTimeout(function() {
            const enrollButtons = document.querySelectorAll('a[href="#enrollment-options"]');
            const contactButtons = document.querySelectorAll('a[href="#contact"]');
            
            enrollButtons.forEach(function(button) {
                button.addEventListener('click', smoothScrollToSection, true);
            });
            
            contactButtons.forEach(function(button) {
                button.addEventListener('click', smoothScrollToSection, true);
            });
            
            console.log('AAC: Found', enrollButtons.length, 'enroll buttons and', contactButtons.length, 'contact buttons');
        }, 500);
    }
    
    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initSmoothScroll);
    } else {
        initSmoothScroll();
    }
    
    // Also initialize after a short delay to override any late-loading scripts
    setTimeout(initSmoothScroll, 100);
    
    // Prevent FAQ accordion errors
    if (typeof jQuery !== 'undefined') {
        jQuery(document).ready(function($) {
            // Override any FAQ handlers that might cause errors
            const originalOn = $.fn.on;
            $.fn.on = function() {
                const args = Array.prototype.slice.call(arguments);
                const events = args[0];
                const selector = args[1];
                
                // Check if this is a FAQ-related event
                if (typeof selector === 'string' && selector.includes('faq')) {
                    // Wrap the handler to add error checking
                    const handler = args[args.length - 1];
                    if (typeof handler === 'function') {
                        args[args.length - 1] = function(e) {
                            try {
                                const element = e.target;
                                if (element && element.classList) {
                                    return handler.apply(this, arguments);
                                }
                            } catch (error) {
                                console.warn('AAC: FAQ handler error prevented:', error);
                            }
                        };
                    }
                }
                
                return originalOn.apply(this, args);
            };
        });
    }
    
    // Prevent errors from undefined elements
    window.addEventListener('error', function(e) {
        if (e.message && (
            e.message.includes("Cannot read properties of undefined (reading 'top')") ||
            e.message.includes("Cannot read properties of null (reading 'classList')") ||
            e.message.includes("Cannot read properties of undefined (reading 'classList')")
        )) {
            e.preventDefault();
            console.warn('AAC: Prevented error - ' + e.message);
            return false;
        }
    }, true);
    
    // Fix 4: Patch FAQ-specific issues
    if (window.FAQs || window.customElements) {
        // Wait for FAQs to be defined
        const checkFAQs = setInterval(function() {
            if (window.FAQs && window.FAQs.prototype) {
                // Override the problematic method
                const originalOnBodyClick = window.FAQs.prototype.onBodyClickEvent;
                window.FAQs.prototype.onBodyClickEvent = function(event) {
                    try {
                        if (!this.filterDropdown || !this.filterDropdownArrow) {
                            return;
                        }
                        if (event.target && event.target.closest && event.target.closest('[data-faqs-filter]') != null) {
                            return;
                        }
                        if (this.filterDropdown && this.filterDropdown.classList && this.filterDropdown.classList.contains('is-show')) {
                            this.filterDropdown.classList.remove('is-show');
                            if (this.filterDropdownArrow && this.filterDropdownArrow.classList) {
                                this.filterDropdownArrow.classList.remove('active');
                            }
                        }
                    } catch (e) {
                        console.warn('AAC: FAQ error prevented:', e);
                    }
                };
                clearInterval(checkFAQs);
            }
        }, 50);
        
        // Stop checking after 5 seconds
        setTimeout(function() {
            clearInterval(checkFAQs);
        }, 5000);
    }
    
    // Fix 5: Intercept window scroll events that might cause errors
    const originalScrollTo = window.scrollTo;
    window.scrollTo = function(x, y) {
        try {
            if (typeof x === 'object' && x !== null) {
                // Handle scrollTo with options
                if (typeof x.top === 'number' && !isNaN(x.top)) {
                    return originalScrollTo.call(this, x);
                }
            } else if (typeof x === 'number' && typeof y === 'number' && !isNaN(x) && !isNaN(y)) {
                // Handle scrollTo with x, y coordinates
                return originalScrollTo.call(this, x, y);
            }
        } catch (e) {
            console.warn('AAC: ScrollTo error prevented:', e);
        }
    };
    
    // Initialize fixes immediately
    console.log('AAC: Error prevention fixes initialized');
})();